<div (window:resize)="onResize($event)"  >
  <div class="search-container">
    <span class="location-icon"> <i *ngIf="appContext.siteName !== 'Sharecare'" class="fa fa-search"></i> <i *ngIf="appContext.siteName === 'Sharecare'" class="fa fa-location-arrow " style="color: #00bfa5;" ></i></span>

    <input
      type="text"
      id="searchInput"
      [ngClass]="{
        'input-text': appContext.siteName !== 'HotelCollection' && appContext.siteName !== 'Sharecare',
        'input-text roboto-regular': appContext.siteName === 'Sharecare',
        'hc-input-text': appContext.siteName === 'HotelCollection',
        'sg-input-text': appContext.siteName == 'ShamalGroup',
        'joy-input-text': appContext.siteName == 'Joy' ? true : appContext.siteName == 'DemoPortal'
      }"
      autocomplete="off"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (keyup)="initiateSearch()"
      [(ngModel)]="searchStr"
      [placeholder]=" appContext.siteName === 'Sharecare' ? SharecareSearchPlaceHolder : searchPlaceholder"
      (click)="getInput()"
    />
    <span *ngIf="showLoader" class="loader"></span>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOptionPanelOpened"
  >
    <div
      class="auto-suggest-picker"
      role="dialog"
      [style.width]="popoverWidth + 'px'"
    >
      <div
        class="auto-suggest-items"
        role="listbox"
        tabindex="0"
        cdkTrapFocus
        cdkFocusAutoCapture
      >
        <ng-content> </ng-content>
      </div>
    </div>
  </ng-template>
</div>
